import { useEffect, useMemo, useState } from "react";

export default function useWebSocket(wsUrl: string, messageTypes: WebSocketMissionType[]) {
  const [message, setMessage] = useState<WebSocketMessage | null>(null);

  const ws = useMemo(() => new WebSocket(`${wsUrl}`), [wsUrl]);

  const handleListenMessage = (message: MessageEvent<string>) => {
    const payload: WebSocketMessage = JSON.parse(message.data);
    if (messageTypes.indexOf(payload.type) >= 0) {
      setMessage(payload);
    }
  };

  useEffect(() => {
    const sendPingMessage = (ws: WebSocket) => {
      ws.send(
        JSON.stringify({
          messageType: "ping",
        })
      );
    };

    let intervalId: NodeJS.Timer;
    ws.addEventListener("open", () => {
      ws.send(
        JSON.stringify({
          messageType: "authentication",
          token: localStorage.getItem("token"),
        })
      );

      // Prevent from websocket timeout
      intervalId = setInterval(() => sendPingMessage(ws), 5000);
    });
    ws.addEventListener("message", handleListenMessage);

    return () => {
      ws.removeEventListener("message", handleListenMessage);
      if (intervalId) {
        clearInterval(intervalId);
      }
      ws.close();
    };
  }, [ws]);

  return { message };
}
